module.exports = __webpack_public_path__ + "img/conclusion2.7d2d9a2b.svg";